import { GetOneFromPath } from '../api/GenericClient';

async function getPrivateIncentiveDataForExport(dealerId: string) {
  return await GetOneFromPath<any>(
    `/common/GetPrivateIncentiveDataForExportAsync?dealerId=${dealerId}`,
  );
}

async function getEEQConquestIncentiveDataForExport(dealerId: string) {
  return await GetOneFromPath<any>(
    `/common/GetEEQConquestIncentiveDataForExport?dealerId=${dealerId}`,
  );
}

async function getEEQConquestIncentiveDataCount(): Promise<any> {
  const url = `/common/GetEEQConquestIncentiveDataCount`;
  return await GetOneFromPath<any>(url);
}

async function getPrivateIncentiveDataCount(): Promise<any> {
  const url = `/common/GetPrivateIncentiveDataCountForExportAsync`;
  return await GetOneFromPath<any>(url);
}

export const DataExportService = {
  getPrivateIncentiveDataForExport,
  getEEQConquestIncentiveDataForExport,
  getEEQConquestIncentiveDataCount,
  getPrivateIncentiveDataCount,
};
